// Add your custom JS here.

import Swiper from 'swiper';
import { Autoplay, Navigation } from 'swiper/modules';

const logo_swiper = new Swiper('.logo-swiper', {
    // Optional parameters
    //direction: 'vertical',
	modules: [Autoplay, Navigation],
    loop: true,
	slidesPerView: 1,
	breakpoints: {
		1200:{
			slidesPerView: 6
		},
        992:{
			slidesPerView: 5
		},
        576:{
			slidesPerView: 3
		}
	},
	autoHeight: true, // Make slides equal height
	autoplay: {
		delay: 10000,
	},
	// Navigation arrows
	navigation: {
		nextEl: '.logo-swiper-button-next',
		prevEl: '.logo-swiper-button-prev',
	},
  });

const client_swiper = new Swiper('.client-swiper', {
    // Optional parameters
    //direction: 'vertical',
	modules: [Autoplay, Navigation],
    loop: true,
	slidesPerView: 1,
	breakpoints: {
        992:{
			slidesPerView: 4
		},
        576:{
			slidesPerView: 3
		}
	},
	autoHeight: true, // Make slides equal height
	autoplay: {
		delay: 10000,
	},
	// Navigation arrows
	navigation: {
		nextEl: '.client-swiper-button-next',
		prevEl: '.client-swiper-button-prev',
	},
  });